/*
 * Copyright (c) Funtip GbR 2018.
 * Simon Oldeboershuis, Perry Prust
 */

import { AnyAction, isType } from 'typescript-fsa';
import { Song } from '../../../services/playlist';
import { setSongList, setSongSearch, setSongSearchCount, setSongSearchCurrentPos, songListSetLoading } from './actions';

export interface SongListState {
    list: Song[];
    searchString: string;
    searchCurrentPos: number;
    searchCount: number;
    searchPageSize: number;
    isLoading: boolean;
}

const initialSongListState: SongListState = {
    list: [],
    searchString: '',
    searchCurrentPos: 0,
    searchCount: 0,
    searchPageSize: 20,
    isLoading: false
};

export function songListReducer(state: SongListState = initialSongListState, action: AnyAction): SongListState {
    if (isType(action, setSongList)) {
        return Object.assign({}, state, { list: action.payload });
    } else if (isType(action, setSongSearch)) {
        return Object.assign({}, state, { searchString: action.payload });
    } else if (isType(action, setSongSearchCount)) {
        return Object.assign({}, state, { searchCount: action.payload });
    } else if (isType(action, setSongSearchCurrentPos)) {
        return Object.assign({}, state, { searchCurrentPos: action.payload });
    } else if (isType(action, songListSetLoading)) {
        return {...state, isLoading: action.payload };
    } else {
        return state;
    }
}
